import React, { useState } from "react";
import Home from "../Home/Home";
import Header from "../Header/Header";
import Row from "../Rows/Row";

function MainBody() {
  const [showHome, setShowHome] = useState(true);
  const toggleHome = (event = true) => {
    setShowHome(event);
  };
  return (
    <div>
      <Header toggleHome={toggleHome} showHome={showHome} />

      {/* {showHome && <Home />} */}
      <>
        <Row genreType="popular" />
        <Row genreType="soul music" />
        <Row genreType="orchestra" />
        <Row genreType="country music" />
        <Row genreType="rock" />
      </>
    </div>
  );
}

export default MainBody;
